import React from 'react';
import Loader from './Loader';
import EmptyState from './EmptyState';

export default function Table({ columns, data, loading, emptyMessage = 'No records found', onRowClick }) {
  if (loading) return <Loader />;
  if (!data?.length) return <EmptyState message={emptyMessage} />;

  return (
    <div className="table-wrapper">
      <table className="table">
        <thead>
          <tr>{columns.map(c => <th key={c.key} style={c.style}>{c.label}</th>)}</tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={row.id || i} onClick={() => onRowClick?.(row)} style={onRowClick ? { cursor: 'pointer' } : {}}>
              {columns.map(c => (
                <td key={c.key} style={c.tdStyle}>
                  {c.render ? c.render(row[c.key], row) : row[c.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}